<div class="customer-info-container">
  <!-- Area 1: Search Interface -->
  <div class="search-area">
    <div class="search-row">
      <label>顧客部署番号</label>
      <input
        type="text"
        [(ngModel)]="departmentCode"
        (input)="onDepartmentCodeInput($event)"
        maxlength="12"
        placeholder="XXX-XXXX-XXX"
        class="department-code-input"
        [class.input-error]="departmentCodeError"
        autocomplete="off"
      />
      <span class="or-label">OR</span>
      <label>支店番号</label>
      <input
        type="text"
        [(ngModel)]="branchNumber"
        (input)="onBranchNumberInput($event)"
        (blur)="onBranchNumberBlur()"
        maxlength="3"
        placeholder="999"
        class="branch-input"
        [class.input-error]="branchNumberError"
        autocomplete="off"
      />
      <span class="plus-sign">+</span>
      <label>会社名(あいまい検索)</label>
      <input
        type="text"
        [(ngModel)]="companyName"
        (input)="onCompanyNameInput()"
        placeholder="会社名を入力"
        class="name-input"
      />
      <button (click)="searchCustomerOffices()" [disabled]="!canSearch()" class="search-button">表示</button>
      <button (click)="onClear()" class="clear-button">クリア</button>
    </div>
    <div class="search-row bulk-row" *ngIf="adminLevel >= 2">
      <label>年月</label>
      <select [(ngModel)]="bulkYearMonth" class="bulk-select">
        <option value="">選択してください</option>
        <option *ngFor="let opt of yearMonthOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
      <label>顧客番号</label>
      <input type="text" [(ngModel)]="bulkCustomerCode" maxlength="8"
        placeholder="XXX-XXXX" class="bulk-code-input" autocomplete="off" />
      <button class="bulk-download-btn"
        (click)="downloadBulkLedgerPdf()"
        [disabled]="!bulkYearMonth || !bulkCustomerCode || isBulkDownloading">
        <span *ngIf="isBulkDownloading">処理中...</span>
        <span *ngIf="!isBulkDownloading">管理台帳一括出力</span>
      </button>
      <span class="bulk-error-inline" *ngIf="bulkErrorMessage">{{ bulkErrorMessage }}</span>
    </div>
    <div class="validation-errors" *ngIf="hasValidationErrors()">
      <div class="error-text" *ngIf="departmentCodeError">{{ departmentCodeError }}</div>
      <div class="error-text" *ngIf="branchNumberError">{{ branchNumberError }}</div>
    </div>
  </div>

  <div class="messages" *ngIf="errorMessage && !showOfficeList && !showOfficeDetail">
    <div class="error-message">{{ errorMessage }}</div>
  </div>

  <!-- Area 2: Office List (shown when searching by branch + name) -->
  <div class="office-list-area" *ngIf="showOfficeList">
    <ul class="office-list">
      <li *ngFor="let office of pagedOfficeList">
        <a (click)="selectOffice(office)" class="office-link">
          {{ office.customerName }} - {{ office.officeName }}
        </a>
      </li>
      <li *ngIf="officeList.length === 0" class="no-data">
        該当するデータがありません
      </li>
    </ul>

    <!-- Pagination -->
    <div class="pagination" *ngIf="officeList.length > pageSize">
      <button (click)="previousPage()" [disabled]="currentPage === 1">前へ</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages">次へ</button>
    </div>
  </div>

  <!-- Area 3: Office Detail -->
  <div class="office-detail-area" *ngIf="showOfficeDetail && selectedOffice">
    <table class="detail-table">
      <tbody>
        <tr>
          <th>顧客部署番号</th>
          <td>{{ selectedOffice.customerOfficeCode }}</td>
        </tr>
        <tr>
          <th>会社名</th>
          <td>{{ selectedOffice.customerName }}</td>
        </tr>
        <tr>
          <th>部署名</th>
          <td>{{ selectedOffice.officeName }}</td>
        </tr>
        <!-- Issue:52対応 住所は表示しない
        <tr>
          <th>住所</th>
          <td>{{ selectedOffice.officeAddress }}</td>
        </tr>
        -->
      </tbody>
    </table>
  </div>

  <!-- Area 4: Job Orders -->
  <div class="job-orders-area" *ngIf="showJobOrders">
    <div class="area-header">直近の獲注</div>
    <table class="data-table">
      <thead>
        <tr>
          <th>獲注番号</th>
          <th>スタッフ番号</th>
          <th>スタッフ氏名</th>
          <th>就業期間</th>
          <th>DT使用期間</th>
          <th>職種</th>
          <th>締日</th>
          <th>最終更新日時</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of jobOrders">
          <td>
            <a *ngIf="job.jobOrderId" (click)="onJobOrderClick(job.jobOrderId)" class="link-text">{{ job.jobOrderId }}</a>
            <span *ngIf="!job.jobOrderId">{{ job.jobOrderId }}</span>
          </td>
          <td>
            <a *ngIf="job.userCode" (click)="onAscClick(job.userCode)" class="link-text">{{ job.userCode }}</a>
            <span *ngIf="!job.userCode">{{ job.userCode }}</span>
          </td>
          <td>{{ job.userName }}</td>
          <td>{{ job.orderDate }}</td>
          <td>{{ job.dtDate }}</td>
          <td>{{ job.jobTitle }}</td>
          <td>{{ job.closeDate }}</td>
          <td>{{ job.editDate }}</td>
        </tr>
        <tr *ngIf="jobOrders.length === 0">
          <td colspan="8" class="no-data">獲注データがありません</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Area 5: Approvers with Editable Emails -->
  <div class="approvers-area" *ngIf="showApprovers">
    <div class="area-header">この顧客に登録された承認者</div>
    <table class="data-table">
      <thead>
        <tr>
          <th>UserID</th>
          <th>承認者氏名</th>
          <th>LoginID</th>
          <th>最終更新日時</th>
          <th>登録メールアドレス</th>
          <th>PR</th>
          <th>修正</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let approver of approvers; let i = index">
          <td>{{ approver.userId }}</td>
          <td>{{ approver.userName }}</td>
          <td>{{ approver.loginId }}</td>
          <td>{{ approver.editDate }}</td>
          <td>
            <input
              #emailInput
              type="email"
              [(ngModel)]="approver.email2"
              class="email-input"
              placeholder="メールアドレスを入力"
              [class.invalid-email]="approver.email2 && !isValidEmail(approver.email2)"
            />
          </td>
          <td class="checkbox-cell">
            <input type="checkbox" [checked]="approver.passwordReset" disabled />
          </td>
          <td>
            <button
              (click)="updateEmail(approver, emailInput)"
              [disabled]="!readWrite || adminLevel < 2 || !isEmailModified(approver) || !isValidEmail(approver.email2)"
              class="action-button"
            >
              修正
            </button>
            <button
              (click)="resetEmail(approver)"
              [disabled]="!readWrite || adminLevel < 2"
              class="action-button reset-button"
            >
              メルアドリセット
            </button>
            <button
              (click)="resetPassword(approver)"
              [disabled]="!readWrite || adminLevel < 2"
              class="action-button password-reset-button"
            >
              パスワードリセット
            </button>
          </td>
        </tr>
        <tr *ngIf="approvers.length === 0">
          <td colspan="7" class="no-data">この顧客に登録された承認者がありません</td>
        </tr>
      </tbody>
    </table>

    <!-- Error/Success Messages -->
    <div class="messages">
      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
      <div class="success-message" *ngIf="successMessage">
        {{ successMessage }}
      </div>
    </div>
  </div>
</div>
